import { GlobalDataLayerService } from './global-data-layer-service';
import { EventAction, EventActions } from '../../utility/constants';

type ComponentClick = { clickElementId: string; clickElementName: string; targetUrl: string };
export class DataLayerEventBuilder {
  private eventAction: EventAction = EventActions.GENERAL_LOAD;
  private eventAttributes: Partial<{ componentClick: Partial<ComponentClick> }> = {};
  public withAction(action: EventAction) {
    this.eventAction = action;
  }

  public withComponentClick(attrs: Partial<ComponentClick>) {
    this.eventAttributes.componentClick = attrs;
  }

  public pushEvent() {
    GlobalDataLayerService.getInstance().pushDataLayerEvent(this.eventAction, this.eventAttributes);
  }
}
